const Historial = () => {
    return (
      <div className="text-center mt-10">
        <h2 className="text-2xl font-semibold text-blue-700">Historial</h2>
        <p className="mt-4 text-gray-600">Visualización de acciones realizadas por los usuarios.</p>
      </div>
    );
  };
  
  export default Historial;
  